import { Formik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { dashboardAction, submitAction } from "../../redux/action";
import { onlyNumber } from "../../constant/utils";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { validateQuickLink } from "../../constant/validation";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  Name: "",
  Email: "",
  Mobile: "",
  Message: "",
  CityId: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha:""
};

const PrenatalTesting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [values, setValues] = useState<any>({ ...initialValue });
  const [collapse, setCollapse] = useState(false);
  const cityData = useSelector((state: any) => state.dashboard.cityAll);

  useEffect(() => {
    window?.scrollTo(0, 0);
    return () => {};
  }, []);

  const handleSubmit = (values: any) => {
    let data: any = values;
    data.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    data.UtmSource = urlParams.get("utm_source");
    data.UtmMedium = urlParams.get("utm_medium");
    data.UtmCampaign = urlParams.get("utm_campaign");
    dispatch(submitAction.submitQueryAction(data, history));
  };
  return (
    <>
      <SeoAdd slug={ROUTE.PRENATALTESTING} />
      <BreadCrumb page={t("prenatal_testing")} data={{ slug: "", path: "" }} />
      <section className="about-section prenanat-about-sec">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-12">
              <div className="overview-wrap text-center mt-3">
                <img
                  src={t("images.prenataltesting.prenataltesting_banner_new_website")}
                  className="scale round_img"
                  alt=""
                />
                <div className="headingmains text-center">
                  <h1 className="right aos-init mt-3 mt-lg-5 mt-3">{t("prenatal_testing")}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="news_section pb-4">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="partnerDetais prenatal-para w-100 scenario-head partnerDetais-par">
                <br></br>
                <p>
                  <strong>{t("prenatal_testing_about1")} </strong>
                </p>
                <br></br>
                <p>{t("prenatal_testing_about2")}</p>
              </div>
            </div>
            <div className="col-md-5">
              <div className="w-100">
                <div className="h-services">
                  <div className="infobox_wrapper pb-2">
                    <Formik
                      initialValues={initialValue}
                      enableReinitialize={true}
                      validationSchema={validateQuickLink}
                      onSubmit={(val: any) => {
                        handleSubmit(val);
                      }}
                      render={({ values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue }:any) => (
                        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                          <h6 className="ln-1 mr-10">{t("neurology_form_title")}</h6>
                          <div className="ln-1 mr-10">{t("neurology_form_note")}</div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="Name"
                              className="form-control"
                              placeholder={t("name")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.Name}
                            />
                            {touched?.Name && errors?.Name && <span className="error_message">{t(errors?.Name)}</span>}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="Mobile"
                              className="form-control"
                              placeholder={t("mobile_number")}
                              onKeyPress={onlyNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.Mobile}
                            />
                            {touched?.Mobile && errors?.Mobile && (
                              <span className="error_message">{t(errors?.Mobile)}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="CityId"
                              id="CityId"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.CityId}
                            >
                              <option value="">{t("city")}</option>
                              {cityData &&
                                cityData.length > 0 &&
                                cityData?.map((item: any, i: any) => (
                                  <option value={item?.Id} key={i} className="text-uppercase">
                                    {t(item?.Name)}
                                  </option>
                                ))}
                            </select>
                            {touched?.CityId && errors?.CityId && (
                              <span className="error_message">{t(errors?.CityId)}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <textarea
                              className="form-control"
                              placeholder={t("message")}
                              name="Message"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.Message}
                            ></textarea>
                            {touched?.Message && errors?.Message && (
                              <span className="error_message">{t(errors?.Message)}</span>
                            )}
                          </div>
                          <div className="d-flex for-check-style">
                            <input
                              type="checkbox"
                              name="Checkbox"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              id="checkbox_id"
                            />
                            <label className="mx-2" htmlFor="checkbox_id">
                              By clicking you accept to the{" "}
                              <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                                terms and conditions
                              </a>{" "}
                              and the{" "}
                              <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                                Privacy Policy.
                              </a>
                            </label>
                          </div>
                          <div>
                            {touched?.Checkbox && errors?.Checkbox && (
                              <span className="error_message">{errors?.Checkbox}</span>
                            )}
                          </div>
                          <div className="form-group">
                            <Recaptcha
                              touch={touched?.GRecaptcha}
                              error={errors?.GRecaptcha}
                              onChange={(token: any) => setFieldValue("GRecaptcha", token)}
                              onExpired={()=> setFieldValue("GRecaptcha", "")}
                            />
                          </div>
                          <button type="submit" className="book--hexagon active">
                            <span>
                              {t("submit_btn")}
                              <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                            </span>
                          </button>
                        </form>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="pink-section w-100"></div>
      <section>
        <div className="print-molecular-dv w-100 nw-sct">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="molecular-main-part w-100 float-left">
                  <div className="molecular-frst-dv w-100 float-left">
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <h2>{t("types_prenatal_testing")}</h2>

                        <div className="row text-hms partnerDetais part-pad0 head-pren">
                          <div className="col-lg-12 sub-head-pren">
                            <p className="sub-head-pren">
                              <strong>{t("types_prenatal_testing_info")} </strong>
                            </p>
                            <h5>{t("screening_tests")}</h5>
                            <p>{t("screening_tests_about")}</p>
                            <h5>{t("diagnostic_tests")}</h5>
                            <p>{t("diagnostic_tests_about")}</p>
                            <h5>{t("1st-trimester_screening_adv")} </h5>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <img src={t("images.prenataltesting.prenatal-types")} alt="" />
                      </div>
                    </div>
                  </div>

                  <div className="molecular-thrd molecular-thrd-pren w-100 float-left">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="molecls-dv w-100 float-left partnerDetais">
                          <h2>{t("types_prenatal_screening_testing")}</h2>
                          <p>{t("prenatal_testing_include")}</p>

                          <h4>{t("first_trimester_tests")}</h4>
                          <img src={t("images.prenataltesting.screening-tests-types")} alt="" />
                          <p>{t("first_trimester_tests_about")} </p>

                          <h4>{t("second_trimester_tests")}</h4>
                          <p>{t("second_trimester_tests_about")}</p>

                          <h4>{t("cell_free_dna_screening")}</h4>
                          <p>{t("cell_free_dna_screening_about1")}</p>
                          <p>{t("cell_free_dna_screening_about2")}</p>

                          <h4>{t("pre_screening_test_results")}</h4>
                          {/* <img src={t("images.neurology.parkison")} alt="" /> */}
                          <p>{t("pre_screening_test_results_info")}</p>

                          <h4>{t("prenatal_care")}</h4>
                          <p>{t("prenatal_care_info")}</p>

                          <h4>{t("pre_accurate_results")}</h4>
                          <p>{t("pre_accurate_results_info")}</p>
                          <h5 className="mb-2">{t("1st-trimester_screening_adv1")}</h5>
                          <ul>
                            <li>{t("decision_to_pursue")}</li>
                          </ul>
                          <h4>{t("neurology_sub_heading8")}</h4>
                          <ul>
                            <li>{t("test_offering1")}</li>
                            <li>{t("test_offering2")}</li>
                            <li>{t("test_offering3")}</li>
                            <li>{t("test_offering4")}</li>
                            <li>{t("test_offering5")}</li>
                            <li>{t("test_offering6")}</li>
                            <li>{t("test_offering7")}</li>
                            <li>{t("test_offering8")}</li>
                            <li>{t("test_offering9")}</li>
                            <li>{t("test_offering10")}</li>
                            <li>{t("test_offering11")}</li>
                            <li>{t("test_offering12")}</li>
                            <li>{t("test_offering13")}</li>
                            <li>{t("test_offering14")}</li>
                            <li>{t("test_offering15")}</li>
                            <li>{t("test_offering16")}</li>
                            <li>{t("test_offering17")}</li>
                            <li>{t("test_offering18")}</li>
                            <li>{t("test_offering19")}</li>
                            <li>{t("test_offering20")}</li>
                            <li>{t("test_offering21")}</li>
                            <li>{t("test_offering22")}</li>
                            <li>{t("test_offering23")}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrenatalTesting;
